import axios from 'axios';
import logger from '../logger';

type LocationListItemType = {
    name: string;
    type: string;
};

export type LocationListType = {
    cookieDomain: string;
    locationList: LocationListItemType[];
    webkit: boolean;
};

const initialState: LocationListType = {
    cookieDomain: '',
    locationList: [],
    webkit: false,
};

const SET_LOCATION_LIST = 'SET_LOCATION_LIST';

export const setLocationList = (payload: LocationListType) => ({
    type: SET_LOCATION_LIST,
    payload,
});

export const updateLocationListThunk = (input: string) => (dispatch) => {
    axios({
        method: 'GET',
        url: `/ajax/location/prefix?input=${input}`,
    })
        .then(function (response) {
            if (response) {
                if (response.status === 200) {
                    dispatch(setLocationList(response.data));
                }
            }
        })
        .catch((error) => {
            logger.error('error fetching location list', `${error}`);
        });
};

type Action = ReturnType<typeof setLocationList>;

export default (state = initialState, action: Action): LocationListType =>
    action.type === SET_LOCATION_LIST ? action.payload || initialState : state;
